import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59bd9af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "images-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.imageList, (image, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "image-wrapper",
        onClick: ($event: any) => ($setup.emitOnClickImage(index))
      }, [
        _createElementVNode("button", {
          class: "selected-image-btn",
          type: "button",
          "aria-label": $props.imageAltTextList[index]
        }, [
          _withDirectives(_createElementVNode("img", {
            src: $props.selectedImageList[index],
            "aria-hidden": "true"
          }, null, 8 /* PROPS */, _hoisted_4), [
            [_vShow, $setup.isSelectedImage(index)]
          ])
        ], 8 /* PROPS */, _hoisted_3),
        _createElementVNode("button", {
          class: "image-btn",
          type: "button",
          "aria-label": `${$props.imageAltTextList[index]} 선택됨`
        }, [
          _withDirectives(_createElementVNode("img", {
            src: image,
            "aria-hidden": "true",
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_6), [
            [_vShow, !$setup.isSelectedImage(index)]
          ])
        ], 8 /* PROPS */, _hoisted_5)
      ], 8 /* PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}